// extracted by mini-css-extract-plugin
export default {"cardSpotlight":"SpotlightCard_cardSpotlight__7TS8p"};